import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as i } from "./index.es2447.js";
function t({ size: V = i }) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: V,
      height: V,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.7778 15C21.2255 15 20.7778 15.4477 20.7778 16V32.7778C20.7778 33.3301 21.2255 33.7778 21.7778 33.7778H31.4392L37.6352 38.2638C37.8335 38.4074 38.1111 38.2657 38.1111 38.0208V33.7778H40C40.5523 33.7778 41 33.3301 41 32.7778V16C41 15.4477 40.5523 15 40 15H21.7778Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M20.7778 20.7778V32.7778C20.7778 33.3301 21.2255 33.7778 21.7778 33.7778H31.4393L32.3333 34.4251V40.0001C32.3333 40.5523 31.8856 41.0001 31.3333 41.0001H16C15.4477 41.0001 15 40.5523 15 40.0001V21.7778C15 21.2255 15.4477 20.7778 16 20.7778H20.7778Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l("path", { d: "M23.6667 20.5972H38.1112V19.5139H23.6667V20.5972Z", fill: "#5E63E5" }),
        /* @__PURE__ */ l("path", { d: "M29.4444 23.4862H25.1111V22.4028H29.4444V23.4862Z", fill: "#5E63E5" }),
        /* @__PURE__ */ l("path", { d: "M38.1112 23.4862H30.889V22.4028H38.1112V23.4862Z", fill: "#5E63E5" }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M38.1112 38.0208C38.1112 38.2657 37.8336 38.4074 37.6352 38.2638L32.3333 34.4251V40.0001C32.3333 40.5523 31.8856 41.0001 31.3333 41.0001H16C15.4477 41.0001 15 40.5523 15 40.0001V21.7778C15 21.2255 15.4477 20.7778 16 20.7778H20.7778V16C20.7778 15.4477 21.2255 15 21.7778 15H40.0001C40.5523 15 41.0001 15.4477 41.0001 16V32.7778C41.0001 33.3301 40.5523 33.7778 40.0001 33.7778H38.1112V38.0208ZM31.7633 32.7778L37.1112 36.6497V32.7778H40.0001V16L21.7778 16V32.7778H31.7633ZM20.7778 21.7778H16V40.0001H31.3333V33.7778H21.7778C21.2255 33.7778 20.7778 33.3301 20.7778 32.7778V21.7778Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
t.__tags = [];
export {
  t as MetricCommentsIcon
};
//# sourceMappingURL=index.es403.js.map
